import Vue from 'vue'
import Vuex from 'vuex'
import fontModule from './modules/font'
import userModule from './modules/user'
import trialsModule from './modules/trials'
import clientsModule from './modules/clients'
import unfoldingsModule from './modules/unfoldings'
import movementsModule from './modules/movements'
import decisionsModule from './modules/decisions'
import courtsModule from './modules/courts'
import partsModule from './modules/parts'
import subjectsModule from './modules/subjects'
import situationsModule from './modules/situations'
import challengeModule from './modules/challenge'
import emailsModule from './modules/emails'
import emailsadmModule from './modules/emailsadm'
import deadlinesModule from './modules/deadlines'
import systemsModule from './modules/systems'
import calculatorsModule from './modules/calculators'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		verbose: false,
	},
	modules: {
		font: fontModule,
		user: userModule,
		trials: trialsModule,
		clients: clientsModule,
		unfoldings: unfoldingsModule,
		movements: movementsModule,
		decisions: decisionsModule,
		courts: courtsModule,
		parts: partsModule,
		subjects: subjectsModule,
		situations: situationsModule,
		challenge: challengeModule,
		emails: emailsModule,
		emailsadm: emailsadmModule,
		deadlines: deadlinesModule,
		systems: systemsModule,
		calculators: calculatorsModule,
	},
	actions: {
		saveCurrentFullPath: function (context, fullPath): void {
			localStorage.currentFullPath = fullPath
		},
	},
})
